import styled from 'styled-components';

import { media } from 'utils/styleUtil';

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  // margin-left: -14px;
  // margin-right: -14px;
`;

export const Column = styled.div`
  width: 100%;
  min-height: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 26px;

  ${({ xs }) => xs && media.phone`max-width: ${100 / xs}%;`}
  ${({ sm }) => sm && media.tablet`max-width: ${100 / sm}%;`}
  ${({ md }) => md && media.miniLaptop`max-width: ${100 / md}%;`}
  ${({ lg }) => lg && media.desktop`max-width: ${100 / lg}%;`}
`;
